import { FC, PropsWithChildren } from 'react';

import cx from 'clsx';

import { Box, BoxProps } from '@mantine/core';

import footerClasses from './Footer.module.css';

interface FooterProps extends BoxProps, PropsWithChildren {
  fixed?: boolean;
  withoutBorder?: boolean;
}

const Footer: FC<FooterProps> = ({
  children,
  fixed,
  withoutBorder,
  className,
  ...rest
}) => {
  return (
    <Box
      {...rest}
      component="footer"
      className={cx(footerClasses.footer, className, {
        [footerClasses.fixed]: fixed,
        [footerClasses.bordered]: !withoutBorder
      })}
    >
      {children}
    </Box>
  );
};

export { Footer };
export type { FooterProps };
